import * as actions from "./welcome.actions";
import * as sagas from "./welcome.sagas";
export { default as Welcome } from "./welcome.component";

export { actions, sagas };
